import { render, staticRenderFns } from "./clap-reset.vue?vue&type=template&id=7dbe7f14&"
import script from "./clap-reset.vue?vue&type=script&lang=js&"
export * from "./clap-reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports